<template>
  <div class="row bg-white"
       :style="props.embedded ? 'height: 100%; display: flex; flex-direction: column; margin: 0;' : ''">
    <div class="col-12"
         :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 0;' : ''">
      <div class="row gy-2"
           :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; margin: 0;' : ''">

        <div v-if="!props.embedded" class="col-12">
          <!-- Filter bar -->
          <div class="dash-filterbar">
            <NSelect
                v-model:value="FILTERS.ELEMENT"
                :disabled="isLoading"
                :options="ELEMENT_OPTS"
                :theme-overrides="inputTheme"
                filterable
                placeholder="Select commodity to view"
                :input-props="{ autocomplete: Math.random() }"
                class="dash-filterbar__select"
                size="small"
            />
            <div class="input-wrapper dash-filterbar__product" style="position: relative;">
              <NSelect
                  v-model:value="FILTERS.PRODUCT"
                  :disabled="isLoading"
                  :options="PRODUCT_OPTS"
                  :theme-overrides="inputTheme"
                  filterable
                  clearable
                  placeholder="Select product to view"
                  :input-props="{ autocomplete: Math.random() }"
                  class="dash-filterbar__select"
                  size="small"
              />
              <div v-if="showToast" class="p-toast" style="position: absolute; top: 100%; left: 0; margin-top: 4px; width: max-content; max-width: 320px; z-index: 10; pointer-events: none;">
                Please select a product from the list before filtering.
                <button class="p-toast__close" aria-label="Dismiss" @click="showToast = false">&#x2715;</button>
              </div>
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">Start</span>
              <NDatePicker
                  v-model:value="yearsView[0]"
                  type="year"
                  clearable
                  :is-date-disabled="disableOutOfRange"
                  :input-props="{ autocomplete: randomId }"
                  class="dash-filterbar__datepicker"
                  size="small"
              />
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">End</span>
              <NDatePicker
                  v-model:value="yearsView[1]"
                  type="year"
                  clearable
                  :is-date-disabled="disableOutOfRange"
                  :input-props="{ autocomplete: randomId }"
                  class="dash-filterbar__datepicker"
                  size="small"
              />
            </div>
            <NButton
                size="small"
                :disabled="isDisabled"
                @click="getTableData()"
                color="#213ce5"
                style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;"
                @mouseenter="e => e.currentTarget.style.border = '1px solid #00aeef'"
                @mouseleave="e => e.currentTarget.style.border = '1px solid transparent'"
            >
              Search
            </NButton>
          </div>

          <!-- Action row -->
          <div class="dash-actions">
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='Table' }" @click="setType('Table')">
              <img :src="DDICONS.table" alt="" class="dash-action-btn__icon" />
              View as table
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='Graph' }" @click="setType('Graph')">
              <img :src="DDICONS.graphic" alt="" class="dash-action-btn__icon" />
              View as Graphic
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType==='All' }" @click="setType('All')">
              <img :src="DDICONS.graphTable" alt="" class="dash-action-btn__icon" />
              View Table &amp; Graphic
            </button>

            <div class="relative inline-block" @focusout="e => { if (!e.currentTarget.contains(e.relatedTarget)) setTimeout(() => menuOpen = false, 100) }">
              <button
                  class="dash-action-btn"
                  :disabled="!activeData || activeData.length === 0"
                  @click="menuOpen = !menuOpen"
              >
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                {{ displayType === 'Graph' ? 'Export Graphic' : displayType === 'All' ? 'Export' : 'Export Data' }}
              </button>
              <div v-show="menuOpen" class="split-menu" role="menu">
                <template v-if="displayType !== 'Graph'">
                  <button role="menuitem" @click="handleExportExcel">Export as Excel</button>
                  <button role="menuitem" @click="handleExportCSV">Export as CSV</button>
                </template>
                <template v-if="displayType !== 'Table'">
                  <button role="menuitem" @click="exportAs('png')">Export as PNG</button>
                  <button role="menuitem" @click="exportAs('svg')">Export as SVG</button>
                </template>
              </div>
            </div>

            <NSwitch
                v-model:value="loadAll"
                :rail-style="railStyle"
                :disabled="activeData.length === 0 || FILTERS.PRODUCT == null"
                @update:value="handleChange"
                :round="false"
                size="small"
            >
              <template #unchecked>Filtered data</template>
              <template #checked>All data</template>
            </NSwitch>

            <NSelect
                v-model:value="FILTERS.COUNTRY"
                :disabled="isLoading || loadAll"
                multiple
                :options="COUNTRY_OPTS"
                :theme-overrides="inputTheme"
                filterable
                clearable
                placeholder="Filter countries"
                :input-props="{ autocomplete: Math.random() }"
                size="small"
                style="flex: 1 1 160px; min-width: 120px; max-width: 240px;"
            />

            <NButton
                size="small"
                :disabled="isDisabled"
                @click="getTableData()"
                color="#213ce5"
                style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent; flex-shrink: 0;"
                @mouseenter="e => e.currentTarget.style.border = '1px solid #00aeef'"
                @mouseleave="e => e.currentTarget.style.border = '1px solid transparent'"
            >
              Refresh
            </NButton>

            <span class="dash-actions__disclaimer" @click="showDisclaimer = true"><em>Disclaimer</em></span>
          </div>
        </div><!-- /v-if="!props.embedded" -->

        <div v-if="needsRefresh && !props.embedded" class="col-12">
          <div class="dash-empty-state">
            Select a commodity and product, then click&nbsp;<strong>Refresh</strong>&nbsp;to load data.
          </div>
        </div>

        <div v-if="!needsRefresh && !props.embedded && (displayType === 'Table' || displayType === 'All')" class="col-12">
          <div class="table-scroll modern-scrollbar">
            <NDataTable
                :style="{ width: tableWidth + 'px' }"
                :columns="columns"
                :data="tableData"
                table-layout="fixed"
                :row-key="rowKey"
                :row-class-name="rowClassName"
                :scroll-x="-1"
                :theme-overrides="tableTheme"
                v-model:expanded-row-keys="expandedRowKeys"
            />
          </div>
        </div>

        <!-- ── Chart block ─────────────────────────────────────────────────── -->
        <div v-if="(props.embedded || !needsRefresh) && (displayType === 'Graph' || displayType === 'All')"
             :class="props.embedded ? '' : 'col-12'"
             :style="props.embedded
               ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; padding: 0; margin-top: 0'
               : 'padding-top: 20px; margin-bottom: 10px;'">
          <div v-if="!props.embedded" class="row gy-3 align-items-center mb-2">
            <div class="col-12 col-md-4">
              <NSelect v-model:value="graphView" :options="GRAPH_VIEW_OPTIONS" :theme-overrides="inputTheme" placeholder="Select graph view" :input-props="{ autocomplete: Math.random() }" />
            </div>
          </div>
          <div oncontextmenu="return false;"
               style="background-color: white;"
               ref="captureDiv"
               :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">
            <div
                style="background: url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center/cover no-repeat; background-size: 60%;"
                :style="props.embedded
                  ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; background-color: #f8f9fa;'
                  : 'background-color: rgba(255,255,255,0.8); padding: 20px;'">
              <div style="position: relative;"
                   :style="props.embedded
                     ? 'flex: 1; min-height: 0; display: flex; flex-direction: column; background-color: #f8f9fa;'
                     : 'background-color: rgba(255,255,255,0.8);'">

                <!-- Loading overlay -->
                <div v-show="isChartLoading"
                     style="position: absolute; inset: 0; display: flex; flex-direction: column;
                            align-items: center; justify-content: center; background: white;
                            z-index: 10; gap: 1.5rem;">
                  <div class="custom-loader">
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                    <div class="loader-circle"/>
                  </div>
                  <p class="loading-text">Loading...</p>
                </div>

                <DynamicChart
                    ref="dynamicChartRef"
                    v-show="!isChartLoading"
                    :chartData="chartData"
                    :options="embeddedOptions"
                    :chart-type="graphView"
                    :height="props.embedded ? '100%' : '500px'"
                    :embedded="props.embedded"
                    :style="props.embedded ? 'flex: 1; min-height: 0;' : ''"
                />
              </div>
            </div>
          </div>
          <p v-if="!props.embedded" style="font-size: smaller;"><em>Source: Project Blue</em></p>
          <p v-if="!props.embedded" style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
        </div>

        <p v-if="!props.embedded && displayType === 'Table'" style="font-size: smaller;"><em>Source: Project Blue</em></p>
        <p v-if="!props.embedded && displayType === 'Table'" style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
      </div>
    </div>
  </div>

  <NDrawer v-model:show="showDisclaimer" :width="400" :height="200" placement="right">
    <TermsAndConditions />
  </NDrawer>
</template>

<script setup>
import { ref, reactive, computed, watch, h, onMounted, onUnmounted, nextTick } from "vue";
import { NSelect, NDataTable, NDatePicker, NButton, NDrawer, NScrollbar, NSwitch } from "naive-ui";
import DynamicChart from "@/components/DynamicChart.vue";
import { SUBSCRIPTION_INFO } from "@/composables/subscription";
import { getSupplyData, supplyData, products, countries, getCommodityProductsAndCountries } from "@/composables/marketData/datadashboards";
import * as htmlToImage from 'html-to-image';
import TermsAndConditions from "./TermsAndConditions.vue";
import { exportToCSV, exportToExcel } from "../../composables/marketData/datadashboards";
import { DDICONS } from "../../composables/generics";
import { logUserAction, USER_ACTIONS } from "@/composables/userLogs";
const props = defineProps({
  embedded: { type: Boolean, default: false },
  embeddedFilters: { type: Object, default: null },
});
const emit = defineEmits(['products-loaded']);

// Isolated data store for embedded mode — never pollutes the shared composable ref
const localSupplyData = ref([]);
const activeData = computed(() => props.embedded ? localSupplyData.value : (supplyData.value ?? []));

const isChartLoading = ref(false);

// Embedded chart title
const embeddedTitle = computed(() => {
  if (!PRODUCT_OPTS.value) return FILTERS.PRODUCT ?? '';
  return PRODUCT_OPTS.value.find(x => x.value === FILTERS.PRODUCT)?.label ?? FILTERS.PRODUCT ?? '';
});

// Chart options with embedded title injection
const embeddedOptions = computed(() => ({
  ...options.value,
  maintainAspectRatio: props.embedded ? false : options.value.maintainAspectRatio,
  height: props.embedded ? undefined : options.value.height,
  plugins: {
    ...options.value.plugins,
    legend: { ...options.value.plugins.legend },
    title: {
      display: props.embedded && !!embeddedTitle.value,
      text: embeddedTitle.value,
      align: 'center',
      position: 'top',
      color: 'black',
      font: { size: 16 },
      padding: { top: 8, bottom: 4 },
    },
  },
  scales: { ...options.value.scales },
}));

const randomId = ref(Math.random().toString());
const inputTheme = {
  peers: {
    InternalSelection: {
      borderHover: '1px solid #213ce5',
      borderFocus: '1px solid #213ce5',
      borderActive: '1px solid #213ce5',
      boxShadowFocus: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowActive: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowHover: 'none',
      caretColor: '#213ce5',
      arrowColorActive: '#213ce5',
      arrowColorHover: '#213ce5',
      color: '#fff',
      colorActive: '#ffffff',
      colorFocus: '#ffffff',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    },
    InternalSelectMenu: {
      optionColorActive: 'rgba(33, 60, 229, 0.08)',
      optionColorActivePending: 'rgba(33, 60, 229, 0.12)',
      optionColorPending: 'rgba(33, 60, 229, 0.05)',
      optionTextColorActive: '#213ce5',
      optionTextColorChildActive: '#213ce5',
      optionCheckColor: '#213ce5',
      actionDividerColor: '#213ce5',
      loadingColor: '#213ce5',
      scrollbarColor: 'rgba(33, 60, 229, 0.3)',
      scrollbarColorHover: 'rgba(33, 60, 229, 0.5)',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    }
  }
};
const tableTheme = {
  thColorSorting: 'transparent',
  thIconColorActive: '#213ce5',
  thIconColor: 'rgba(33, 60, 229, 0.3)',
  sorterColor: '#213ce5',
  sorterColorActive: '#213ce5',
};
let tableWidth = ref(2500);
const dynamicChartRef = ref(null)
const handleClickOutside = (e) => {
  if (!e.target.closest('.relative.inline-block')) {
    menuOpen.value = false;
    menuGraphOpen.value = false;
  }
};

const ELEMENT_OPTS = computed(() => {
  return SUBSCRIPTION_INFO?.dataElements?.map((nth) => ({
    label: nth.name,
    value: nth.code,
  }));
});

const COUNTRY_OPTS = computed(() => {
  return (countries.value ?? []).map((nth) => ({
    label: nth.name,
    value: nth.code,
  }));
});

const PRODUCT_OPTS = computed(() => {
  return (products.value ?? []).map((nth) => ({
    label: nth.name,
    value: nth.code,
  }));
});

const handleChange = (newVal) => {
  if (FILTERS.PRODUCT == null) {
    loadAll.value = false;
    FILTERS.COUNTRY = null;
    return;
  }
  if (newVal == true) {
    getTableDataAll();
  } else {
    FILTERS.COUNTRY = null;
    getTableData();
  }
};

const rowClassName = (row) => {
  return row._rowType === 'child-header'
      ? 'child-header-row'
      : row._rowType === 'child'
          ? 'child-row'
          : '';
};

const FILTERS = reactive({
  SUBSCRIPTION: null,
  ELEMENT: null,
  SUB_ELEMENT: null,
  COMPANY: null,
  COUNTRY: null,
  ASSET: null,
  PRODUCT: null,
});

const GRAPH_VIEW_OPTIONS = ref([
  { label: 'Bar Chart', value: 'bar' },
  { label: 'Line Chart', value: 'line' },
]);

const decimals = ref(0);
const supplyUom = ref("Supply");
const isSearch = ref(false);
const lastYearStart = ref(2015);
const lastYearEnd = ref(2035);
const showDisclaimer = ref(false);
const loadAll = ref(false);
const captureDiv = ref(null);
const showOptions = ref(false);
const isLoading = ref(true);
const showToast = ref(false);
const needsRefresh = ref(true);
const displayType = ref("Table");

let isMounted = false;
let isResettingExpanded = false;

const graphView = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const yearsView = ref([
  (new Date(2015, 0)).getTime(),
  (new Date(2035, 0)).getTime(),
]);
const updatedDate = ref(new Date());

function setType(type) {
  displayType.value = type;
  if (!props.embedded) localStorage.setItem("displayTypeSupply", type);
  // Track display mode switch (Table, Graph, All)
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Switched Supply view to: "${type}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}", Product: "${FILTERS.PRODUCT || 'All'}")`
  );
}

function railStyle({ focused, checked }) {
  const style = {
    fontSize: '14px',
    border: '1px solid transparent',
    height: '20px',
  };
  style.background = 'linear-gradient(90deg, #213ce5, #2380f2)';
  if (focused) {
    style.boxShadow = 'none';
  }
  return style;
}

function checkProductMatch(savedProduct) {
  const matched = products.value.find(x => x.code == savedProduct);
  if (matched) {
    FILTERS.PRODUCT = matched.code;
    showToast.value = false;
    yearsView.value = [
      new Date(matched.startYear, 0).getTime(),
      new Date(matched.endYear, 0).getTime()
    ];
  } else {
    FILTERS.PRODUCT = null;
    showToast.value = true;
  }
}

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  if (!props.embedded) {
    FILTERS.ELEMENT = sessionStorage.getItem("element") ?? ELEMENT_OPTS.value[0].value;
    isLoading.value = false;
    const savedProduct = sessionStorage.getItem("productSupply");
    FILTERS.COUNTRY = JSON.parse(sessionStorage.getItem("countries"));
    if (FILTERS.COUNTRY == "All") { loadAll.value = true; }
    displayType.value = localStorage.getItem("displayTypeSupply") ?? "Table";

    await getCommodityProductsAndCountries(FILTERS.ELEMENT, "Supply");
    checkProductMatch(savedProduct);
    if (FILTERS.PRODUCT) { getTableData(); }

    watch(() => FILTERS.ELEMENT, async (newVal) => {
      await getCommodityProductsAndCountries(newVal, "Supply");
      checkProductMatch(sessionStorage.getItem("productSupply"));
      needsRefresh.value = true;
    });
  } else {
    isLoading.value = false;
    displayType.value = "Graph";
    const element = props.embeddedFilters?.element ?? ELEMENT_OPTS.value?.[0]?.value ?? null;
    const product  = props.embeddedFilters?.product  ?? null;
    if (element && product) await fetchEmbedded(element, product);
  }
  isMounted = true;
});
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
watch(() => FILTERS.PRODUCT, (newVal) => {
  if (newVal != null) {
    sessionStorage.setItem("productSupply", newVal);
    showToast.value = false;
  }
});
// Isolated fetch for embedded mode
async function fetchEmbedded(element, product) {
  if (!element || !product) return;

  isChartLoading.value = true;

  try {
    FILTERS.ELEMENT = element;
    FILTERS.PRODUCT = product;

    // Same source of truth the non-embedded view initializes from
    // (checkProductMatch), so the embedded date range matches it instead of
    // being derived from whatever data happens to come back for the
    // (still-default) query window.
    await getCommodityProductsAndCountries(element, "Supply");
    const matchedProduct = products.value.find(x => x.code === product);
    if (matchedProduct?.startYear != null && matchedProduct?.endYear != null) {
      yearsView.value = [
        new Date(matchedProduct.startYear, 0).getTime(),
        new Date(matchedProduct.endYear, 0).getTime()
      ];
    }

    await getSupplyData(
        element,
        product,
        null,
        new Date(yearsView.value[0]).getFullYear(),
        new Date(yearsView.value[1]).getFullYear()
    );

    localSupplyData.value = JSON.parse(
        JSON.stringify(supplyData.value ?? [])
    );

    supplyData.value = [];

    decimals.value = localSupplyData.value[0]?.decimalPlaces ?? 0;

    getChartData();

    // Force embedded charts to render as stacked bars
    if (chartData.value?.datasets?.length) {
      chartData.value.datasets.forEach(ds => {
        ds.type = "bar";
        ds.stack = "1";
        ds.fill = false;
        ds.tension = 0;
      });
    }

    if (options.value?.scales?.yLeft) {
      options.value.scales.yLeft.stacked = true;
    }

    if (options.value?.scales?.x) {
      options.value.scales.x.stacked = true;
    }

    graphView.value = "bar";

    await nextTick();
    await new Promise(resolve => setTimeout(resolve, 400));

    dynamicChartRef.value?.renderChart(embeddedTitle.value);
  } finally {
    isChartLoading.value = false;
    await nextTick();
  }
}

// Re-fetch when dashboard pushes new filters
watch(
    () => props.embeddedFilters,
    async (f) => {
      if (!props.embedded || !f?.element) return;

      // Element changed → refresh product list
      await getCommodityProductsAndCountries(f.element, "Supply");

      emit(
          "products-loaded",
          (products.value ?? []).map(p => ({
            label: p.name,
            value: p.code,
          }))
      );

      // Only fetch chart data if a product is selected
      if (f.product) {
        await fetchEmbedded(f.element, f.product);
      }
    },
    { deep: true, immediate: true }
);
const menuOpen = ref(false);
const menuGraphOpen = ref(false);

const exportAs = async (type) => {
  menuOpen.value = false;
  menuGraphOpen.value = false;
  // Track graphic download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_GRAPH,
    `Exported Supply graphic as ${type.toUpperCase()} (Commodity: "${FILTERS.ELEMENT || 'N/A'}", Product: "${FILTERS.PRODUCT || 'All'}")`
  );
  if (type === 'svg') downloadAsSvg();
  else downloadAsPng();
};

const handleExportExcel = () => {
  menuOpen.value = false;
  exportToExcel(tableData.value, minYear.value, maxYear.value, 'Supply.xlsx', 'supply');
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Supply data as Excel (Commodity: "${FILTERS.ELEMENT || 'N/A'}", Product: "${FILTERS.PRODUCT || 'All'}")`
  );
};

const handleExportCSV = () => {
  menuOpen.value = false;
  exportToCSV(tableData.value, minYear.value, maxYear.value, 'Supply.csv', 'supply');
  // Track CSV download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Supply data as CSV (Commodity: "${FILTERS.ELEMENT || 'N/A'}", Product: "${FILTERS.PRODUCT || 'All'}")`
  );
};

const downloadAsSvg = () => {
  htmlToImage.toSvg(captureDiv.value).then(dataUrl => {
    const link = document.createElement("a");
    link.download = "capture.svg";
    link.href = dataUrl;
    link.click();
    showOptions.value = false;
  });
};

const downloadAsPng = () => {
  htmlToImage.toPng(captureDiv.value).then(dataUrl => {
    const link = document.createElement("a");
    link.download = "capture.png";
    link.href = dataUrl;
    link.click();
    showOptions.value = false;
  });
};

const minYear = computed(() => {
  if (!activeData.value?.length) return null;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  let minYear = Math.min(...activeData.value.map(x => x.startYear).filter(y => y != null));
  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min > minYear ? min : minYear;
});

const maxYear = computed(() => {
  if (!activeData.value?.length) return null;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  let maxYear = Math.max(...activeData.value.map(x => x.endYear).filter(y => y != null));
  let max = allYears.length ? Math.max(...allYears) : null;
  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear;
});

const columns = computed(() => {
  let columnStart = minYear.value;
  let columnEnd = maxYear.value;

  if(FILTERS.PRODUCT){
    columnStart = new Date(yearsView.value[0]).getFullYear();
    columnEnd = new Date(yearsView.value[1]).getFullYear();
  }

  let response = [
    {
      title: "Country",
      key: "country",
      width: "190px",
      fixed: 'left',
      render(row) { return row._rowType === 'child' ? '' : row.country; }
    },
    {
      title: "Product",
      key: "productForm",
      width: "190px",
      fixed: 'left',
      render(row) {
        return row._rowType === 'child'
            ? row.assetName
            : row.productForm.length > 25 ? `${row.productForm.substring(0, 25)}...` : row.productForm;
      }
    },
    {
      title: "Units",
      key: "units",
      width: "120px",
      fixed: 'left',
      render(row) {
        return row._rowType === 'child' ? (row.companyName || '') : row.units;
      }
    },
    ...Array.from({ length: columnEnd - columnStart + 1 }, (_, i) => ({
      title: `${columnStart + i}`,
      key: `${columnStart + i}`,
      width: "110px",
      align: "right"
    }))
  ];

  response.forEach(col => {
    col.sortable = true;
    col.sortOrder = 'asc';
    col.sorter = (a, b, order) => {
      const valA = (a[col.key] ?? '').toString().replace(/,/g, '');
      const valB = (b[col.key] ?? '').toString().replace(/,/g, '');
      let result;
      if (!isNaN(valA) && !isNaN(valB)) {
        result = Number(valA) - Number(valB);
      } else {
        result = String(valA).localeCompare(String(valB));
      }
      return order === 'desc' ? -result : result;
    };
  });

  return response;
});

const getUoms = () => {
  let data = tableData.value;
  supplyUom.value = `Supply (${data[0].units})`;
};

const tableData = computed(() => {
  const startYears = (activeData.value || []).map(d => d.startYear);
  const endYears = (activeData.value || []).map(d => d.endYear);
  let min = Math.min(...startYears);
  let max = Math.max(...endYears);
  lastYearStart.value = min === 0 ? 2015 : min;
  lastYearEnd.value = max === 0 ? 2035 : max;

  return (activeData.value || []).map((item, index) => {
    const copy = { ...item };
    copy._rowType = 'parent';
    copy.key = `parent-${index}`;

    const years = copy.yearlyData;
    if (years && typeof years === 'object') {
      for (const [year, value] of Object.entries(years)) {
        copy[year] = value.toLocaleString('en', {
          minimumFractionDigits: decimals.value,
          maximumFractionDigits: decimals.value,
        });
      }
    }
    delete copy.yearlyData;

    if (Array.isArray(item.countryLevelData) && item.countryLevelData.length > 0) {
      const children = [];
      children.push({
        _rowType: 'child-header',
        country: '',
        productForm: 'Asset Name',
        units: 'Company Name'
      });
      item.countryLevelData.forEach(child => {
        const c = { ...child };
        c._rowType = 'child';
        c.country = '';
        c.productForm = child.assetName;
        c.units = child.companyName || '';
        if (c.yearlyData && typeof c.yearlyData === 'object') {
          for (const [year, value] of Object.entries(c.yearlyData)) {
            c[year] = value.toLocaleString('en', {
              minimumFractionDigits: decimals.value,
              maximumFractionDigits: decimals.value,
            });
          }
        }
        delete c.yearlyData;
        children.push(c);
      });
      copy.children = children;
    }
    return copy;
  });
});

const rowKey = (row) => row.key;
const expandedRowKeys = ref([]);

// Track table row expand / collapse
watch(expandedRowKeys, (newKeys, oldKeys) => {
  if (!isMounted || isResettingExpanded) return;
  const oldSet = new Set(oldKeys || []);
  const newSet = new Set(newKeys || []);

  const added = (newKeys || []).filter(k => !oldSet.has(k));
  const removed = (oldKeys || []).filter(k => !newSet.has(k));

  if (added.length > 0) {
    const row = tableData.value?.find(r => r.key === added[0]);
    const countryName = row?.country || added[0];
    logUserAction(
      USER_ACTIONS.VIEW_DASHBOARD,
      `Expanded Supply table (Country: "${countryName}", Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
    );
  } else if (removed.length > 0) {
    const row = tableData.value?.find(r => r.key === removed[0]);
    const countryName = row?.country || removed[0];
    logUserAction(
      USER_ACTIONS.VIEW_DASHBOARD,
      `Collapsed Supply table (Country: "${countryName}", Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
    );
  }
}, { deep: true });

const minFilterYear = computed(() => {
  if (!activeData.value?.length) return 2015;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  let minYear = Math.min(...activeData.value.map(x => x.startYear).filter(y => y != null));
  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min < minYear ? min : minYear;
});

const maxFilterYear = computed(() => {
  if (!activeData.value?.length) return 2035;
  const allYears = activeData.value.flatMap(item => Object.keys(item.yearlyData || {}).map(Number));
  let maxYear = Math.max(...activeData.value.map(x => x.endYear).filter(y => y != null));
  let max = allYears.length ? Math.max(...allYears) : null;
  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear;
});

const disableOutOfRange = (timestamp) => {
  const year = new Date(timestamp).getFullYear();

   if (selectedProductInfo.value) {
    return (
      year < selectedProductInfo.value.startYear ||
      year > selectedProductInfo.value.endYear
    );
  }

  return year < minFilterYear.value || year > maxFilterYear.value;
};

const chartData = ref({
  labels: Array.from({ length: 21 }, (_, i) => (2015 + i).toString()),
  datasets: [],
});

const getChartData = () => {
  getUoms();

  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();
  const years = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const colors = [
    '#213CE5', '#00AEEF', '#009A46', '#92D050', '#F0C302',
    '#6801FF', '#9484FF', '#f25c05', '#FC9860', '#F58231',
    '#911EB4', '#46F0F0', '#F032E6', '#D2F53C', '#FABEBE',
    '#008080', '#E6BEFF', '#AA6E28', '#FFFAC8', '#800000',
    '#AAFFC3', '#808000', '#FFD8B1', '#000080', '#808080',
    '#000000', '#9A6324', '#469990', '#DCBEFF', '#FFB6C1',
    '#40E0D0', '#6495ED', '#228B22', '#B8860B', '#A52A2A',
    '#5F9EA0', '#D2691E', '#708090', '#FF4500', '#ADFF2F',
    '#8A2BE2', '#20B2AA', '#FFD700', '#B22222', '#7FFF00',
    '#FF69B4', '#BA55D3', '#00CED1', '#DAA520',
  ];
  const colorFor = i => colors[i % colors.length];

  const datasets = (activeData.value || [])
      .slice()
      .map((item, idx) => {
        const yearly = item.yearlyData || {};
        const data = years.map(y => {
          const v = yearly[String(y)];
          return v === undefined || v === null ? null : Number(v);
        });
        return {
          label: `${item.country || 'Unknown'}`.trim(),
          data,
          borderColor: colorFor(idx),
          backgroundColor: colorFor(idx),
          borderWidth: 2,
          yAxisID: 'yLeft',
          fill: true,
          stacked: false,
          type: 'line',
          order: idx,
        };
      });

  chartData.value.labels = years;
  chartData.value.datasets = datasets;
};

const isDisabled = computed(() => {
  return FILTERS?.ELEMENT == "" || FILTERS?.ELEMENT == undefined
      || FILTERS?.PRODUCT == "" || FILTERS?.PRODUCT == undefined;
});

const getTableDataAll = async () => {
  FILTERS.COUNTRY = ["All"];
  getTableData();
};

const getTableData = async () => {
  needsRefresh.value = false;
  isResettingExpanded = true;
  expandedRowKeys.value = [];
  await nextTick();
  isResettingExpanded = false;

  if (FILTERS.COUNTRY == "[All]" && !loadAll.value) {
    FILTERS.COUNTRY = null;
  }
  graphView.value = null;

  const startYearNum = new Date(yearsView.value[0]).getFullYear();
  const endYearNum = new Date(yearsView.value[1]).getFullYear();

  // Track search query execution
  logUserAction(
    USER_ACTIONS.SEARCH_DASHBOARD,
    `Searched Supply: Commodity="${FILTERS.ELEMENT || 'N/A'}", Product="${FILTERS.PRODUCT || 'All'}", Years=${startYearNum}-${endYearNum}`
  );

  await getSupplyData(FILTERS.ELEMENT, FILTERS.PRODUCT, FILTERS.COUNTRY,
      startYearNum,
      endYearNum);

      
  if (!FILTERS.PRODUCT) {
    const start = minYear.value;
    const end = maxYear.value;

    yearsView.value = [
      (new Date((start == 'Infinity' || start == null ? 2015 : start), 0)).getTime(),
      (new Date((end == '-Infinity' || end == null ? 2035 : end), 0)).getTime(),
    ];
  }

  tableWidth.value = ((columns.value.length - 3) * 110) + 750;

  decimals.value = activeData.value[0]?.decimalPlaces ?? 1;
  getChartData();
  dynamicChartRef.value?.renderChart();
  graphView.value = GRAPH_VIEW_OPTIONS.value[0].value;
  isSearch.value = true;
};

const options = ref({
  responsive: true,
  maintainAspectRatio: false,
  width: '100%',
  height: 700,
  plugins: {
    legend: {
      position: 'bottom',
      labels: { boxWidth: 20, padding: 15, color: 'black' },
      onClick: () => { return; },
    },
  },
  scales: {
    x: {
      stacked: true,
      type: 'category',
      ticks: { color: 'black' },
      grid: { drawOnChartArea: false },
    },
    yLeft: {
      stacked: true,
      min: 0,
      grid: { drawOnChartArea: false },
      title: {
        display: true,
        text: `${supplyUom.value}`,
        font: { size: 16 },
        color: 'black',
      },
      ticks: {
        color: 'black',
        callback: (value) =>
            Number(value).toLocaleString('en-US', {
              minimumFractionDigits: decimals.value,
              maximumFractionDigits: decimals.value,
            }),
      },
    },
  },
});

watch([supplyUom], () => {
  options.value.scales.yLeft.title.text = `${supplyUom.value}`;
});

watch(ELEMENT_OPTS, () => {
  if (props.embedded) return;
  FILTERS.ELEMENT = ELEMENT_OPTS.value[0].value;
  getTableData();
});

watch(
    () => FILTERS.COUNTRY,
    (newVal) => {
      let max = 9;
      if (FILTERS.COUNTRY?.length > max) {
        FILTERS.COUNTRY = FILTERS.COUNTRY.slice(0, max);
        window.$message.warning(`You may only select up to ${max} countries at a time.`);
      }
      sessionStorage.setItem("countries", JSON.stringify(newVal ?? []));
      loadAll.value = FILTERS.COUNTRY == "All";
    }
);

watch(graphView, () => {
  if (chartData.value?.datasets?.length == 0) return;

  if (graphView.value === 'bar') {
    chartData.value.datasets.forEach(ds => { ds.type = 'bar'; ds.stack = '1'; });
    options.value.scales.yLeft.stacked = true;
  } else if (graphView.value === 'line') {
    chartData.value.datasets.forEach(ds => { ds.type = 'line'; ds.fill = false; delete ds.stack; });
    options.value.scales.yLeft.stacked = false;
  } else {
    chartData.value.datasets.forEach(ds => { ds.type = 'line'; ds.fill = true; ds.stack = '1'; });
    options.value.scales.yLeft.stacked = true;
  }
  nextTick(() => dynamicChartRef.value?.renderChart());
});

watch(() => SUBSCRIPTION_INFO?.dataElements, async (newValue, oldValue) => {
  if (props.embedded) return;
  if (newValue?.length > 0 && oldValue?.length === 0) {
    FILTERS.ELEMENT = newValue[0].code;
    await getTableData();
  }
}, { immediate: true });

const selectedProductInfo = computed(() =>
  products.value?.find(x => x.code === FILTERS.PRODUCT)
);
watch(
  selectedProductInfo,
  (product) => {
    if (!product) return;

    yearsView.value = [
      new Date(product.startYear, 0).getTime(),
      new Date(product.endYear, 0).getTime()
    ];
  }
);
</script>

<style lang="scss">
.n-switch__checked,
.n-switch__unchecked {
  display: flex !important;
  align-items: center !important;
}
/* ── Filter bar ── */
.dash-filterbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;

  .n-date-picker {
    .n-input {
      --n-border: 1px solid #e0e0e6 !important;
      --n-border-hover: 1px solid #2184ff !important;
      --n-border-focus: 1px solid #2184ff !important;
      --n-border-active: 1px solid #2184ff !important;
      --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
      --n-caret-color: #2184ff !important;
    }
    .n-date-panel {
      --n-item-color-active: #2184ff !important;
      --n-item-text-color-active: #fff !important;
      --n-item-color-hover: rgba(33, 132, 255, 0.1) !important;
    }
  }

  .n-base-selection {
    --n-border: 1px solid #e0e0e6 !important;
    --n-border-hover: 1px solid #2184ff !important;
    --n-border-focus: 1px solid #2184ff !important;
    --n-border-active: 1px solid #2184ff !important;
    --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
    --n-caret-color: #2184ff !important;
    --n-arrow-color-hover: #2184ff !important;
    --n-arrow-color-active: #2184ff !important;
  }
}

/* ── Toast visuals only — positioning is inline in the template ── */
.p-toast {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff8e5;
  color: #5f4b00 !important;
  border-left: 3px solid #f6c343;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px !important;
  line-height: 1.4 !important;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.p-toast__close {
  background: none;
  border: none;
  cursor: pointer;
  color: #5f4b00;
  font-size: 12px;
  line-height: 1;
  padding: 2px 4px;
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0.6;
  pointer-events: auto;
  &:hover { opacity: 1; }
}

.dash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  color: #000;
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: 'GilroyMedium', sans-serif;
  text-align: center;
  background: #f2f2f2;
}

.dash-filterbar__select {
  flex: 1 1 200px;
  min-width: 120px;
  max-width: 280px;
}

.dash-filterbar__product {
  flex: 1 1 200px;
  min-width: 120px;
  max-width: 280px;
  position: relative;
}

.dash-filterbar__date {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.dash-filterbar__label {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}

.dash-filterbar__datepicker {
  width: 110px;
  min-width: 90px;
}

/* ── Action row ── */
.dash-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  row-gap: 0.25rem;
}

.dash-actions .n-switch {
  flex-shrink: 0;
}

.dash-action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #000;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.15s, border-color 0.15s;

  &--active {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:hover:not(&--active):not(:disabled) {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.dash-action-btn__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
}

.dash-actions__disclaimer {
  margin-left: auto;
  font-size: 11px;
  color: #9dabaf;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover { text-decoration: underline; }
}

@media (max-width: 639px) {
  .dash-filterbar__select,
  .dash-filterbar__product {
    max-width: 100%;
    flex-basis: 100%;
  }

  .dash-filterbar__date {
    flex: 1 1 auto;
  }

  .dash-filterbar__datepicker {
    width: 100%;
    min-width: 80px;
  }
}

.n-date-panel-actions__suffix > .n-button {
  display: none !important;
}

p {
  font-size: 14px !important;
  line-height: 1.625 !important;
  font-weight: 400 !important;
}

.split-btn {
  display: inline-flex;
  border-radius: 3px;
  overflow: hidden;
  height: 34px;
}

.primary {
  background: #00213b;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0 14px;
}

.split-menu {
  position: absolute;
  margin-top: 6px;
  width: 140px;
  background: white;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.split-menu button {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: 12px !important;
  padding: 6px 10px;
}

.split-menu button:hover {
  background: rgba(37, 99, 235, 0.08);
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.child-header-row .n-data-table-td {
  font-weight: bold;
  background-color: #f5f5f5;
  font-size: small !important;
}

.child-row .n-data-table-td {
  background-color: #f5f5f5;
}

.n-data-table-td {
  white-space: nowrap !important;
}

.table-scroll.modern-scrollbar {
  overflow-x: auto;
  overflow-y: visible;
  height: auto;
}
</style>